import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  Input,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Badge,
  Select,
  MenuItem,
  Avatar,
  Dialog,
  DialogTitle,
  DialogContentText,
  DialogActions,
  DialogContent,
  Fab,
  Typography
} from "@material-ui/core";

import {
  Visibility,
  VisibilityOff,
  WarningOutlined,
  CheckOutlined,
  Edit,
  EditOutlined,
  CheckBoxOutlined,
  CheckBoxOutlineBlankOutlined,
  ClearOutlined
} from "@material-ui/icons/";
import { generateKeyPair } from "crypto";
import WorkOrderDetails from "../work-order-details/work-order-details";

const defaultFontSize = "2rem";

const styles = theme => ({
  formCls: {
    display: "flex",
    flexGrow: 1
  },
  root: {
    padding: ".5rem",
    width: "100%",

    overflowX: "auto"
  },
  table: {
    minWidth: 650,
    display: "flex"
  },
  checkBoxColor: {
    color: "grey"
  },
  selected: {
    color: "#ff6c00 !important"
  },
  padding25: {
    padding: ".5rem"
  },
  margingrl25: {
    margin: "0 .25rem"
  },
  mb5: {
    marginBottom: ".5rem"
  },
  ml1: {
    marginLeft: ".5rem"
  },
  headerBg1: {
    backgroundColor: "#1b3e71",
    color: "white",
    fontSize: ".85rem"
  },
  badgecls: {
    color: "whitesmoke",
    backgroundColor: "green",
    right: "1.25rem",
    fontSize: "1rem"
  },
  dflex: {
    display: "flex"
  },
  flexend:{
    justifyContent:'flex-end'
  },
  cursorPointer: {
    cursor: "pointer;"
  },
  hide: {
    display: "none"
  },
  fab:{
    backgroundColor:"#cc1e1ede",
  },
  fabHover:{
    backgroundColor:'yellow'
  },
  fullWidth:{
    width:"80%"
  },
  fsColor:{
    backgroundColor: "#989898db"
  },
  headerStyle: {
    color: "#6975c3"
  },
});

class TrackOrders extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
      storeFilter: " ",
      filterTerm: "",
      mode: 0,
      columns: [],
      rows: [],
      openOrders: [],
      storeItems: [],

      workOrderIsVisible: false,
      workOrder: 0,
      storeId: 0
    };
  }

  componentWillMount = () => {
    this.getWorkOrders();

    //this.fakeRowClick({storeId:1009,workOrder:256618});
  };

  handleModeChange = mode => {
    this.setState(
      {
        mode
      },
      () => this.getWorkOrders()
    );
  };

  getWorkOrderEndPoint() {
    switch (this.state.mode) {
      case 0: {
        return "getOpenWorkOrders";
      }
      case 1: {
        return "getClosedWorkOrders";
      }
      case 2: {
        return "getNteWorkOrders";
      }
    }
  }

  getWorkOrders = () => {
    let endPoint = this.getWorkOrderEndPoint();

    let url = this.state.isProd ? `/api/${endPoint}` : `https://localhost:44331/api/${endPoint}`;

    $.ajax({
      type: "POST",
      url: url,
      data: { customerId: this.props.customerDetail.Id },
      success: result => {
        console.log({ result });
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });

        //   if(resultFormed.result !== 0){
        //     this.props.loginEvent(resultFormed.result);
        //     return;
        //   }

        // this.setState({
        //   storeItems: resultFormed.results
        // });

        this.parseData(resultFormed.results);
      },
      error: result => {
        console.error(result);
      }
    });
  };

  
  parseData = data => {

    let columnNames = [];
    let rows = [];

    if(data.length > 0){
      columnNames = Object.keys(data[0]);
      rows = Object.values(data);
    }
    
    this.setState({
      columns: columnNames,
      rows
    });
  };

  handleRowClick = item => {
    
    this.setState({
      storeId:item.StoreID,
      workOrder:item.OrderNumber,
      workOrderIsVisible:true
    })
  };

  fakeRowClick({storeId, workOrder}){
    this.setState({
      storeId,
      workOrder,
      workOrderIsVisible:true
    })
  }

  handleClose = () => {
    this.setState({
      workOrderIsVisible: false
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.formCls}>
        <Paper className={classes.root}>

        <Typography
          variant="h4"
          gutterBottom
          align="center"
          className={classes.headerStyle}
        >
          Existing Orders
        </Typography>

          <div
            className={[classes.padding25, classes.mb5, classes.dflex].join(
              " "
            )}
          >
            <Button
              variant="contained"
              color={this.state.mode == 0 ? "primary" : "default"}
              className={classes.margingrl25}
              onClick={() => this.handleModeChange(0)}
            >
              Open
              {this.state.mode === 0 ? (
                <CheckBoxOutlined
                  className={[
                    classes.checkBoxColor,
                    classes.selected,
                    classes.ml1
                  ].join(" ")}
                />
              ) : (
                <CheckBoxOutlineBlankOutlined
                  className={[classes.checkBoxColor, classes.ml1].join(" ")}
                />
              )}
            </Button>

            <Button
              variant="contained"
              color={this.state.mode == 1 ? "primary" : "default"}
              className={classes.margingrl25}
              onClick={() => this.handleModeChange(1)}
            >
              Completed
              {this.state.mode === 1 ? (
                <CheckBoxOutlined
                  className={[classes.checkBoxColor, classes.selected].join(
                    " "
                  )}
                />
              ) : (
                <CheckBoxOutlineBlankOutlined
                  className={classes.checkBoxColor}
                />
              )}
            </Button>

            <Button
              variant="contained"
              color={this.state.mode == 2 ? "primary" : "default"}
              className={classes.margingrl25}
              onClick={() => this.handleModeChange(2)}
            >
              NTE
              {this.state.mode === 2 ? (
                <CheckBoxOutlined
                  className={[classes.checkBoxColor, classes.selected].join(
                    " "
                  )}
                />
              ) : (
                <CheckBoxOutlineBlankOutlined
                  className={classes.checkBoxColor}
                />
              )}
            </Button>

            <div>
              {/* <Avatar
                className={classes.badgecls}
                
              >{this.state.rows.length}</Avatar>*/}
            </div>
          </div>
          <Badge
            classes={{ badge: classes.badgecls }}
            badgeContent={this.state.rows.length}
            max={999}
            className={classes.table}
          >
            <Table>
              <TableHead>
                <TableRow>
                  {this.state.columns.map(column => (
                    <TableCell
                      align="center"
                      key={column}
                      className={column === "StoreID" ? classes.hide : null}
                      classes={{ head: classes.headerBg1 }}
                    >
                      {column}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {this.state.rows.map((row, index) => (
                  <TableRow
                    classes={{ hover: classes.cursorPointer }}
                    key={index}
                    hover
                    onClick={() => this.handleRowClick(row)}
                  >
                    {this.state.columns.map(column => (
                      <TableCell
                        align="center"
                        key={row[column]}
                        className={column === "StoreID" ? classes.hide : null}
                      >
                        {row[column]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Badge>

          <Dialog
            fullWidth={true}
            maxWidth="xl"
            // fullScreen
            open={this.state.workOrderIsVisible}
            onClose={this.handleClose}                
          >
            <DialogTitle id="alert-dialog-title" className={[classes.dflex, classes.flexend].join(" ")}>
            <Fab color="primary" title="Close" className={classes.fab} onClick={this.handleClose}>
            <ClearOutlined />
          </Fab>
            </DialogTitle>
            <DialogContent>
              <WorkOrderDetails workOrder={this.state.workOrder} storeid={this.state.storeid}></WorkOrderDetails>
            </DialogContent>
            
          </Dialog>
        </Paper>
      </div>
    );
  }
}

export default withStyles(styles)(TrackOrders);
